var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndpointmanager(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9766 19.5469V9H27V19.5469H32.9766ZM34.5234 6.04688C34.9453 6.04688 35.2969 6.1875 35.5781 6.46875C35.8594 6.75 36 7.10156 36 7.52344V22.5C36 22.9219 35.8594 23.2969 35.5781 23.625C35.2969 23.9062 34.9453 24.0469 34.5234 24.0469H25.5234C25.1016 24.0469 24.7266 23.9062 24.3984 23.625C24.1172 23.2969 23.9766 22.9219 23.9766 22.5V7.52344C23.9766 7.10156 24.1172 6.75 24.3984 6.46875C24.7266 6.1875 25.1016 6.04688 25.5234 6.04688H34.5234ZM5.97656 3.02344V19.5469H21.0234V24.0469H0V19.5469H3.02344V3.02344C3.02344 2.22656 3.30469 1.52344 3.86719 0.914062C4.47656 0.304687 5.17969 0 5.97656 0H32.9766V3.02344H5.97656Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpointmanager);
export default __webpack_public_path__ + "static/media/endpoint manager.50c12a38732865c265333d5742e3b7be.svg";
export { ForwardRef as ReactComponent };